import React, { forwardRef } from 'react'

import { RichTextEditorCore } from './components/editor/index'
import { useWebMentionMenu } from './components/mention-list/use-web-mention-menu'
import { Toolbar } from './components/toolbar/index'
import type { RteHandle, RteProps } from './types'

/**
 * The editor with the Radix toolbar and mention popup wired in. This is the
 * web entry point and what the barrel exports. Mobile imports `./native`.
 */
export const RichTextEditor = forwardRef<RteHandle, RteProps>(
  function RichTextEditor(
    { users = [], usersLoading = false, onInvite, ...props },
    ref,
  ) {
    const mentionMenu = useWebMentionMenu(users, usersLoading, onInvite)

    return (
      <RichTextEditorCore
        {...props}
        ref={ref}
        renderToolbar={ctx => <Toolbar {...ctx} />}
        mentionMenu={mentionMenu}
      />
    )
  },
)
